<template>
<vx-card>
    <vs-tabs >
        <vs-tab label="Menu" class="mt-4">
            <VueMenu />
        </vs-tab>
        <vs-tab label="Perfiles" class="mt-4">
            <VueGrupo />
        </vs-tab>
    </vs-tabs>
</vx-card>
</template>

<script>
import VueMenu from '../menu/listaMenu.vue';
import VueGrupo from '../grupo/lista.vue';
export default {
    components: {
        VueMenu,
        VueGrupo,
    },    
}
</script>
